// extracted by mini-css-extract-plugin
export var blok_class = "index-module--blok_class--d3347";
export var card_container = "index-module--card_container--c6f3d";
export var card_wrapper = "index-module--card_wrapper--7dc6c";
export var cards_outer = "index-module--cards_outer--259a4";
export var tax_tips = "index-module--tax_tips--1d7fc";
export var tax_tips_text = "index-module--tax_tips_text--1afa4";
export var wrapper = "index-module--wrapper--e0b1a";